import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
